import { all, fork } from "redux-saga/effects";

import mainSaga from "./main/saga";
import uiSaga from "./ui/saga";
import searcherSaga from "./search/saga";
import chatSaga from "./chat/saga";
import calendarSaga from "./calendar/saga";

const rootSaga = function* () {
  yield all([
    fork(mainSaga),
    fork(uiSaga),
    fork(searcherSaga),
    fork(chatSaga),
    fork(calendarSaga),
  ]);
};

export default rootSaga;
